import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  content: {
    display: 'flex',
    gap: `${theme.spacing(4)} !important`,
    flexDirection: 'row',
    marginTop: -theme.spacing(1),
  },
  subHeadingContainer: {
    width: '100%',
  },
  verticalDivider: {
    width: '1px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '4px',
    background: theme.palette.dividerV2.main,
  },
  videoContainer: {
    width: '254px !important',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  thumbnailImages: {
    width: '240px',
    height: '135px',
    cursor: 'pointer',
    marginBottom: theme.spacing(1.125),
    borderRadius: '4px',
  },
  videoWrapper: {
    width: '400px',
    backgroundColor: theme.palette.textBackground.light,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(3, 4),
    gap: theme.spacing(2),
    borderRadius: '4px',
    maxHeight: '239px',
    alignSelf: 'center',
  },
  thumbnailWrapper: {
    position: 'relative',
    display: 'inline-block',
  },
  playButton: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer',
    opacity: '0.19',
    width: '78px',
    height: '50px',
    color: theme.palette.black.dark,
  },
  textHeaderContainer: {
    width: '400px',
  },
  heading: {
    color: theme.palette.labraText.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    marginBottom: theme.spacing(1),
  },
  linkText: {
    color: theme.palette.select.light,
    fontFamily: theme.typography.fontFamily,
    textDecoration: 'none',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0.1px',
  },
  subHeading: {
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    marginBottom: theme.spacing(2),
  },
}))
